module.exports = __webpack_public_path__ + "img/1sb-five-stars-orange-new_mob.029ab5c.svg";